import request from '@/utils/httpRequest'

export default class DecomposeService {
    queryById (id) {
        return request({
            url: '/shye/report/shyeFeeAssessment/queryById',
            method: 'get',
            params: {id: id}
        })
    }

	startFlow (params) {
		return request({
		  url: '/shye/report/shyeFeeAssessment/startFlow',
		  method: 'post',
		  data: params
		})
	}
}
